<template>
  <v-container fluid>
    <h2 class="pt-0">HORNO</h2>
    <v-divider class="mb-3"></v-divider>
    <v-row no-gutters >
      <v-col cols="12" sm="6" class="pr-1">
        <v-card>
          <v-card-title>{{$t('delivery.states.PREPARING')}}</v-card-title>
          <order-flow-table ref="PREPARING" state="PREPARING" :action-prev="false"
                            @orderUpdateNext="$refs.READY.fetchOrders()" :show-icons="false"
                            :disable-headers="['contact.name', 'payment.confirmed', 'location.address', 'totalAmount','delivery.distance','deliveryUser.username']"
          />

        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>{{$t('delivery.states.READY')}}</v-card-title>
          <order-flow-table ref="READY" state="READY" delivery-user-read-only
                            @orderUpdatePrev="$refs.PREPARING.fetchOrders()"  :show-icons="false"
                            :disable-headers="['contact.name', 'payment.confirmed','totalAmount','location.address','delivery.distance', 'actions','deliveryUser.username']"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderFlowTable from "@/modules/delivery/components-core/business/OrderFlowTable/OrderFlowTable";


export default {
  name: "OrderFlowOvenPage",
  components: {OrderFlowTable},
  mounted() {
    this.$store.dispatch('fetchCategories')
  }
}
</script>

<style scoped>

</style>
